<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-id exCollection="rollOutExCollection" refCollection="" @ready="onReady" @error="onError"
          @saved="onSaved" @savedNext="onSavedNext" @loadedEx="onLoadedEx" @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef" :doc="doc" :shared="false" :projectShared="false" :pid="true"
          :eid="$route.params.eid" :synced="false">
          <template slot-scope="{ saveExercise, doc }">
            <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline">Roll Out Planning</h2>
              </v-col>
            </v-row>

            <v-row v-if="doc">
              <v-col cols="4">
                <v-card>
                  <v-card-title>
                    Document settings
                  </v-card-title>
                  <v-card-text>
                    <v-text-field label="Title" v-model.trim="doc.title" type="text" required :hide-details="false"
                      color="amber"></v-text-field>

                    <v-select label="Column width" v-model.trim="doc.cols"
                      :items="['1', '2', '3', '4', '6', '12', 'auto']" />

                    <v-select label="Theme" v-model.trim="doc.theme" :items="['dark', 'light']" />

                    <v-select label="Type" v-model.trim="doc.type" :items="['large', 'medium', 'small', 'waterfall']" />

                    <div class="d-flex flex-wrap">
                      <v-switch v-model="doc.controls" label="Controls" color="amber" class="mr-3 ml-3"
                        inset></v-switch>

                      <v-switch v-model="doc.note" label="Description" color="amber" class="mr-3 ml-3" inset></v-switch>

                      <v-switch v-model="doc.tags" label="Phasing" color="amber" class="mr-3 ml-3" inset></v-switch>

                      <v-switch v-model="doc.stats" label="Sliders" color="amber" class="mr-3 ml-3" inset></v-switch>

                      <!-- <v-switch v-model="doc.score" label="Score" color="amber" class="mr-3 ml-3" inset></v-switch> -->

                      <v-switch v-model="doc.touchpoints" label="Touchpoints" color="amber" class="mr-3 ml-3"
                        inset></v-switch>

                      <v-switch v-model="doc.children" label="Children" color="amber" class="mr-3 ml-3"
                        inset></v-switch>

                      <v-switch v-model="doc.edit" label="Edit" color="amber" class="mr-3 ml-3" inset></v-switch>
                    </div>
                    <p class="white--text text-h6 mt-8">Filters</p>
                    <v-select label="Priority" v-model.trim="doc.filters.priorities"
                      :items="['', ...doc.local.priorities]" />
                    <v-select label="Brand" v-model.trim="doc.filters.brand" :items="['', ...doc.local.brand]" />
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="8">
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>
                        Add a new group
                      </v-card-title>
                      <v-card-text>
                        <div class="d-flex align-end justify-space-between">
                          <v-text-field v-model="listName" label="Page title" :hide-details="true" class="ma-0"
                            color="amber" placeholder="Group name"></v-text-field>

                          <v-btn @click="addList" color="amber" class="ma-0 ml-5" light>Add Section</v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <template v-if="doc.edit">
                    <v-col cols="6">
                      <div class="d-flex">
                        <unit-sub-items v-model="doc.local.categories" name="sub" :dark="false">
                          <v-label :light="true">Define the categories for each</v-label>
                          <p class="ma-0">
                            Type below and press <strong>Add</strong>
                          </p>
                        </unit-sub-items>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="d-flex">
                        <unit-sub-items v-model="doc.local.brand" name="sub" :dark="false">
                          <v-label :light="true">Define responsibility / lead</v-label>
                          <p class="ma-0">
                            Type below and press <strong>Add</strong>
                          </p>
                        </unit-sub-items>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="d-flex">
                        <unit-sub-items v-model="doc.local.priorities" name="sub" :dark="false">
                          <v-label :light="true">Define the priorities</v-label>
                          <p class="ma-0">
                            Type below and press <strong>Add</strong>
                          </p>
                        </unit-sub-items>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="d-flex">
                        <unit-sub-items v-model="doc.local.effort" name="sub" :dark="false">
                          <v-label :light="true">Define the effort (financial and leadtime)</v-label>
                          <p class="ma-0">
                            Type below and press <strong>Add</strong>
                          </p>
                        </unit-sub-items>
                      </div>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
            </v-row>

            <v-sheet :color="computedTheme" class="mt-4">
              <div class="pa-4">
                <v-row>
                  <v-col cols="12">
                    <div class="">
                      <draggable :class="doc.cols === 'auto' ? 'auto' : 'row'" group="outer" :list="doc.list" id="iso">
                        <structure-col v-for="(item, index) in doc.list" :key="`list-${index}`" v-model="item.children"
                          :item="item" :attrs="{
                            cols: doc.cols,
                            controls: doc.controls,
                            theme: doc.theme,
                            score: doc.score,
                            children: doc.children,
                            type: doc.type,
                            note: doc.note,
                            tags: doc.tags,
                            filters: doc.filters,
                            touchpoints: doc.touchpoints,
                            stats: doc.stats,
                            add: true,
                            local: doc.local,
                          }" class="iso-item" @onChangeName="onChangeName" @onEditList="onEditList"
                          @onDeleteList="onDeleteList"></structure-col>
                      </draggable>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-sheet>
            <v-row v-if="doc.allItems.length">
              <v-col cols="12">
                <h2 class="subtitle-2 mt-5 mt-5">Deleted items</h2>
                <div class="">
                  <structure-col v-for="(item, index) in doc.allItems" :key="`list-${index}-${item.id}`"
                    v-model="item.children" :item="item" :attrs="{
                      brand: doc.brand,
                      cols: doc.cols,
                      score: doc.score,
                      controls: doc.controls,
                      note: doc.note,
                      children: doc.children,
                      tags: doc.tags,
                      stats: doc.stats,
                      filters: doc.filters,
                      prefix: doc.prefix,
                      touchpoints: doc.touchpoints,
                      theme: doc.theme,
                      type: doc.type,
                      local: doc.local,
                      add: false,
                    }"></structure-col>
                </div>
              </v-col>
            </v-row>


            <bottom-navigation v-if="doc" :save="true" :next="false" :prev="false" :gridView="false" :gridToggle="false"
              :list="`roll-out`" @save="saveExercise(true)" @prev="prevStep" @next="saveExercise(false)">
            </bottom-navigation>
          </template>
        </exercise-logic-id>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title class="headline" v-text="$t('exercise_service.saved.title')"></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicId } from "@/components/exercises";

import { UnitSubItems } from "@/components/units";

import draggable from "vuedraggable";

import { StructureCol } from "@/views/user/exercises/roll-out";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserRollOutId",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      iso: null,
      moveEl: null,
      moveList: null,
      dialogMode: "add",
      allItems: null,
      listName: "",
      test: false,
      revision: 1,
      doc: {
        cols: "4",
        list: [],
        allItems: [],
        title: "",
        controls: true,
        theme: "light",
        type: "large",
        note: false,
        touchpoints: false,
        tags: false,
        stats: true,
        score: true,
        graph: false,
        children: false,
        edit: true,
        logos: false,
        categories: [],
        filters: {
          priorities: [],
          brand: []
        },
        local: {
          effort: [],
          categories: [],
          priorities: [],
          brand: [],
        },
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicId,
    StructureCol,
    UnitSubItems,
    draggable,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    computedWidth() {
      if (this.doc) {
        let unit = 50 / 10;
        return { width: `${unit * this.doc.cols}%` };
      } else {
        return null;
      }
    },
    computedTheme() {
      return this.doc.theme === "light" ? "grey lighten-4" : "grey darken-3";
    },
  },

  watch: {
    doc: {
      deep: true,
      handler() {
        this.revision++;
      },
    },
  },
  mounted() { },

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() { },
    onError() {
      console.log("error");
    },
    onSaved() {
      this.dialog = true;
      this.dialogMode = "save";
    },
    onLoadedRef(refs) {
      if (refs) {
        this.refs = refs[0];
      }
    },
    onLoadedEx(items) {
      // this.initIso();
      if (items) {
        this.mergeArrays(items[0].doc);
        if (items.length) {
          this.doc.controls = items[0].doc.controls;
          this.doc.note = items[0].doc.note;
        }
      }
    },
    onModifyEx(items) {
      if (items) {
        this.exercises = [...items];
      }
    },
    onSavedNext() {
      this.nextStep();
    },
    addList() {
      if (this.listName) {
        let lc = this.listName.replace(/\s/g, "").toLowerCase();
        this.doc.list.push({
          id: new Date().valueOf(),
          title: this.listName,
          name: lc,
          children: [],
        });
        this.listName = "";
      }
    },
    onChangeName(params) {
      const item = this.doc.list.find((x) => x.id === params.id);
      const indexOfItem = this.doc.list.indexOf(item);
      let lc = params.title.replace(/\s/g, "").toLowerCase();
      item.title = params.title;
      item.name = lc;
      this.$set(this.doc.list, indexOfItem, item);
      console.log("on change name", params, indexOfItem);
    },
    onDeleteList(params) {
      console.log("delete list");
      // loop through elements in list and re-distribute to master list
      let item = this.doc.list.find((x) => x.id === params.id);
      let index = this.doc.list.indexOf(item);
      this.cloneChildren(item);
      this.doc.list.splice(index, 1);
    },
    cloneChildren(item) {
      const items = [...item.children];
      this.doc.allItems.push({
        title: "Deleted Items",
        name: "deleted",
        children: items,
      });
    },
    onEditList(params) {
      let item = this.doc.list.find((x) => x.id === params.id);
      if (item) {
        let index = this.doc.list.indexOf(item);
        item = {
          ...params,
        };
        this.$set(this.doc.list, index, item);
      }
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      if (this.doc) {
        Object.entries(arr).forEach(([outerKey, value]) => {
          if (typeof value === "object") {
            Object.entries(value).forEach(([key, value]) => {
              this.doc[outerKey][key] = value;
            });
          }
          if (typeof value === "string") {
            this.doc[outerKey] = value;
          }
          if (typeof value === "boolean") {
            this.doc[outerKey] = value;
          }
        });
      } else {
        this.doc = arr;
      }
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
  },
};
</script>

<style lang="scss">
.auto {
  display: flex;
  flex-wrap: nowrap;

  .col-auto {
    width: auto;
    flex: 1;
  }
}
</style>